import React from 'react';

const BankTransferIcon = ({
  className,
  strokeColor = 'var(--foreground)',
}: {
  className?: string;
  strokeColor?: string;
}) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1 6.5L10 1L19 6.5M3 17H17M8 6H12M4 14V9M8 14V9M12 14V9M16 14V9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={strokeColor}
      />
    </svg>
  );
};

export default BankTransferIcon;
